<template>
  <div>
    <div class="row">
      <div class="col-lg-3 filters-wrapper">
        <div class="filters">
          <div class="block block-fx-pop block-mode-loading-oneui filter">
            <div class="block-header block-header-default">
              <h3 class="block-title">Zoeken</h3>
            </div>
            <div class="block-content p-0">
              <div class="input-group input-group-lg bg-white">
                <input type="search" class="form-control form-control-alt bg-white border-0 pr-0" placeholder="Zoeken.." v-model="search" />
                <div class="input-group-append">
                  <span class="input-group-text bg-white border-0">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="block block-fx-pop block-mode-loading-oneui filter pb-3" v-for="filter in filters" :key="filter.key">
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ filter.name }}</h3>
            </div>
            <div class="block-content p-0">
              <div class="input-group input-group-sm bg-white" v-if="filter.key == 'site'">
                <input
                  type="text"
                  class="form-control form-control-alt bg-white border-0 pr-0"
                  placeholder="Zoeken.."
                  v-model="filter.search"
                  v-on:keyup="toggleFilterSearch(filter.key, $event)"
                />
                <div class="input-group-append">
                  <span class="input-group-text bg-white border-0">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>

              <div class="dropdown-item" v-for="data in filter.visible" :key="data.value" v-on:click.stop.prevent="toggleFilter(filter.key, data)">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="data.value"
                    :name="data.value"
                    :checked="isSelectedFilter(filter.key, data.value)"
                    v-on:change.prevent="toggleFilter(filter.key, data)"
                  />
                  <label class="custom-control-label d-flex align-items-baseline" :for="data.value"
                    >{{ data.name | capitalize }}
                    <i
                      class="fas fa-question-circle ml-2"
                      v-if="data.tooltip"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="data.tooltip"
                      :data-original-title="data.tooltip"
                    ></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="sites-wrapper">
          <div class="block block-fx-pop block-mode-loading-oneui filter pb-3">
            <div class="block-header block-header-default">
              <h3 class="block-title">Bulk acties</h3>
            </div>
            <div class="block-content d-flex align-items-center justify-content-between">
              <div class="bulk-count">{{ selectedLinks.length }} link{{ selectedLinks.length > 1 ? 's' : '' }} geselecteerd</div>
              <div class="bulk-actions">
                <button v-if="!allSelected" :disabled="!isLoaded" class="btn btn-outline-primary mr-2" v-on:click.prevent="selectAll">
                  <!-- <i class="far fa-square"></i> -->
                  <i class="far fa-check-square"></i>
                  Alles selecteren
                </button>
                <button v-if="allSelected" class="btn btn-outline-primary mr-2" v-on:click.prevent="deSelectAll">
                  <i class="far fa-square"></i>
                  Alles deselecteren
                </button>
                <button
                  class="btn btn-outline-success mr-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Toevoegen aan winkelwagen"
                  data-original-title="Toevoegen aan winkelwagen"
                  v-on:click.prevent="importCart"
                  :disabled="selectedLinks.length === 0"
                >
                  <i class="fas fa-cart-plus"></i>
                </button>
                <button
                  href="javascript:void(0)"
                  class="btn btn-outline-danger"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Links verwijderen"
                  data-original-title="Links verwijderen"
                  v-on:click.prevent="bulkDelete"
                  :disabled="selectedLinks.length === 0"
                >
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>

          <bs-site-table-block
            v-for="(site, index) in visibleSites"
            :key="site.id"
            :ref="'site_' + site.id"
            :site="site"
            :selectedFilters="selectedFilters"
            :cartItems="cartItems"
            :selectedLinks="selectedLinks"
            @allSelected="onAllSelected($event, site.id)"
            @loaded="loaded(index)"
          ></bs-site-table-block>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import Fuse from 'fuse.js';
import EventBus from '../plugins/vue-event-bus';
import { mapState } from 'vuex';

export default {
  props: ['sites'],
  data: () => {
    return {
      isLoaded: false,
      allSelected: false,
      allSelectedSites: {},
      search: '',
      cartItems: [],
      visibleSites: [],
      selectedLinks: [],
      selectedFilters: [],
      filters: {
        site: {
          search: '',
          key: 'site',
          name: 'Startpagina',
          data: [],
          visible: [],
        },
        status: {
          key: 'status_name',
          name: 'Status',
          visible: [
            {
              value: 'Binnenkort online',
              name: 'Binnenkort online',
            },
            {
              value: 'Actief',
              name: 'Actief',
            },
            {
              value: 'Verloopt bijna',
              name: 'Verloopt bijna',
              tooltip: '`Verloopt bijna’ zijn links die binnen 60 dagen verlopen',
            },
            {
              value: 'Verlopen',
              name: 'Verlopen',
            },
          ],
        },
        type: {
          key: 'page_type',
          name: 'Type',
          visible: [
            {
              value: 'home',
              name: 'Homepagina link',
            },
            {
              value: 'daughter',
              name: 'Dochterpagina link',
            },
          ],
        },
      },
    };
  },
  watch: {
    allSelectedSites: function(newVal) {
      this.allSelected = Object.keys(newVal).length === this.visibleSites.length;
    },
    cart: function() {
      this.cartItems = !_.isEmpty(this.cart) ? this.cart.cart_items : [];
    },
    search: function() {
      this.addSearch();
    },
    selectedFilters: function() {
      var selectedFilteredSites = this.selectedFilters
        .filter((filter) => {
          return filter.key === 'site';
        })
        .map((filter) => {
          return this.sites.find((site) => site.id === filter.value);
        });

      this.selectedLinks = [];
      this.visibleSites = selectedFilteredSites.length > 0 ? selectedFilteredSites : this.sites;
    },
    selectedLinks: function() {
      setTimeout(() => {
        window.One.helpers(['core-bootstrap-tooltip']);
      }, 200);
    },
  },
  computed: {
    ...mapState('cart', ['cart']),
  },
  created() {
    this.visibleSites = this.sites;
    this.filters.site.data = this.filters.site.visible = this.sites.map((site) => {
      return {
        value: site.id,
        name: site.name,
      };
    });
  },
  methods: {
    loaded(index) {
      this.visibleSites[index].loaded = true;
      
      if (this.visibleSites.every(site => site.loaded)) {
        this.isLoaded =  true;
      }
    },
    isSelectedFilter: function(key, value) {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === key && sFilter.value === value;
      });

      return index >= 0;
    },
    addSearch() {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === 'search';
      });

      if (index >= 0) {
        if (this.search.length === 0) {
          this.removeFilter(index);
        } else {
          this.$set(this.selectedFilters, index, {
            key: 'search',
            label: this.search,
            value: this.search,
          });
        }
      } else if (this.search.length > 0) {
        this.selectedFilters.push({
          key: 'search',
          label: this.search,
          value: this.search,
        });
      }
    },
    toggleFilter(filter, filterobj) {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === filter && sFilter.value === filterobj.value;
      });

      if (index >= 0) {
        this.selectedFilters.splice(index, 1);
      } else {
        this.selectedFilters.push({
          key: filter,
          value: filterobj.value,
          label: filterobj.name,
        });
      }
    },
    toggleFilterSearch(filter, event) {
      if (event.target.value) {
        var fuse = new Fuse(this.filters[filter].data, {
          threshold: 0.2,
          includeScore: false,
          useExtendedSearch: true,
          keys: ['name'],
        });
        this.filters[filter].visible = fuse.search(event.target.value).map((result) => {
          return result.item;
        });
      } else {
        this.filters[filter].visible = this.filters[filter].data;
      }
    },
    removeFilter(index) {
      this.selectedFilters.splice(index, 1);
    },
    onAllSelected(value, site_id) {
      var allSelectedSites = Object.assign({}, this.allSelectedSites);

      if (value && !allSelectedSites[site_id]) {
        allSelectedSites[site_id] = value;
      } else if (!value && allSelectedSites[site_id]) {
        delete allSelectedSites[site_id];
      }

      this.allSelectedSites = allSelectedSites;
    },
    deSelectAll() {
      this.visibleSites.forEach((vSite) => {
        this.$refs[`site_${vSite.id}`][0].toggleAllLinksFromParent(false);
      });
    },
    selectAll() {
      this.visibleSites.forEach((vSite) => {
        this.$refs[`site_${vSite.id}`][0].toggleAllLinksFromParent(true);
      });
    },
    importCart() {
      axios
        .post(route('cart.import'), {
          links: this.selectedLinks.map((link) => {
            return {
              site_id: link.site.id,
              link_id: link.id,
              page_id: link.category.page.id,
              category_id: link.category.id,
              title: link.title,
              url: link.url,
              description: link.description,
              follow: link.follow,
              period: 1,
              start_date: moment(link.expired_at).format('YYYY-MM-DD'),
            };
          }),
        })
        .then((response) => {
          if (response.status == 200 && response.data) {
            if (response.data.success) {
              EventBus.publish('cart.refresh');

              this.selectedLinks = [];

              this.$notify({
                group: 'main',
                type: 'success',
                title: `Geselecteerde links zijn toegevoegd en staan in de winkelwagen klaar voor betaling`,
              });
            }
          }
        });
    },
    bulkDelete() {
      var accept = confirm('Weet u zeker dat u de geselecteerde links wilt verwijderen?');
      if (accept === true) {
        axios
          .post(route('links.bulk-delete'), {
            links: this.selectedLinks.map((link) => {
              return {
                site_id: link.site.id,
                link_id: link.id,
              };
            }),
          })
          .then((response) => {
            if (response.status == 200 && response.data) {
              if (response.data.success) {
                this.$notify({
                  group: 'main',
                  type: 'success',
                  title: `Geselecteerde links zijn verwijdert`,
                });

                this.selectedLinks = [];
                window.location.reload();
              }
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filters-wrapper {
  .search-wrapper {
    height: 80px;
    background: white;
    padding: 0 30px;
    border: 1px solid #eaeaea;
    border-radius: 40px;

    .tags {
      .tag {
        height: 40px;
        padding: 0 15px;
        margin: 0 10px 0 0;
        background: #de7a01;
        color: white;
        border-radius: 6px;
        line-height: 40px;
        font-size: 14px;
        font-weight: bold;
        transition: background 0.3s ease;

        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }

    input {
      height: 70px;
      font-size: 20px;
      border: none;
      outline: none;

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }

  .filters {
    .filter {
      .block-content {
        max-height: 250px;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }
}

.sites-wrapper {
  @media (max-width: 992px) {
    padding-bottom: 80px;
  }
}
</style>
